import { MaintenanceDeviceProvider } from './contexts/MaintenanceDeviceProvider/MaintenanceDeviceProvider';
import MaintenanceDeviceContent from './components/MaintenanceDeviceContent/MaintenanceDeviceContent';
import buttonImage from './assets/overwatch-control.png';
import externalConfig from './configs/externalSrcConfig.json';
import { Container } from 'react-bootstrap';

const MaintenanceDevices = () => {
  return (
    <MaintenanceDeviceProvider>
      <Container fluid className="d-flex flex-column h-100 min-h-0 py-3 overflow-hidden">
        <div className="d-flex flex-column gap-3 flex-grow-1 min-h-0 overflow-hidden">
          {/* Header */}
          <div className="d-flex flex-column flex-md-row space-between align-items-center flex-shrink-0">
            <h2 className="fs-4 mb-0">Maintenance Devices</h2>
            <a
              className="bg-primary-highlight rounded-4 d-flex align-items-center justify-content-center"
              href={externalConfig.inControlUrl}
              target="_blank"
              rel="noreferrer"
              style={{ height: '50px' }}
            >
              <img src={buttonImage} alt="Overwatch Control Portal" style={{ height: '40px' }} />
            </a>
          </div>
          {/* Body */}
          <MaintenanceDeviceContent />
        </div>
      </Container>
    </MaintenanceDeviceProvider>
  );
};

export default MaintenanceDevices;
